import React, { ReactNode, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoImage from '../../assets/images/landing-logo.svg';

type Props = {
    referral_code?: string;
    children: ReactNode;
    headTitle: Array<Object>;
    pathName: string;
    id?: string;
};
const LandingRightSection: React.FC<Props> = ({ children, referral_code, headTitle, pathName, id }) => {
    const navigate = useNavigate();

    const [isVertical, setIsVertical] = useState(false);
    const [restart, setRestart] = useState(true);

    useEffect(() => {
        if (window.innerWidth < 700) {
            setIsVertical(true);
        }
        if (restart) {
            setRestart(false);
        }

        function handleResize() {
            setIsVertical(window.innerWidth < 700 ? true : false);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [restart]);

    return (
        <div
            className={`landing-right flex shrink-0 h-full justify-center min-h-screen bg-white overflow-auto max-h-screen ${
                isVertical && referral_code ? 'pt-0' : 'pt-10 xl:pt-20'
            }`}
            id={id}
        >
            <div className={`w-4/5 md:w-1/2 ${referral_code ? 'pt-8' : 'pt-0'} md:pt-0 `}>
                <div className={`${referral_code ? 'hidden' : 'flex'} md:flex justify-center mb-6`}>
                    <img src={LogoImage} alt="logo" />
                </div>
                <div className={`flex ${referral_code ? 'justify-center' : 'justify-evenly'}`}>
                    {headTitle.map((head: any, i: number) => (
                        <div
                            key={`head_${i}`}
                            onClick={() => (referral_code ? '' : navigate(head.path))}
                            className={`text-center text-base WorkSans-Semibold ${
                                pathName === head.path ? 'landing-right-title' : 'landing-right-disable-title'
                            } cursor-pointer`}
                        >
                            {head.title}
                            {pathName === head.path && <p className="landing-right-title-underline"></p>}
                        </div>
                    ))}
                </div>
                <div>{children}</div>
            </div>
        </div>
    );
};
export default LandingRightSection;
